__turbopack_context__.v({
  "heroIntroContainer": "hero-intro-public-module-scss-module__O7Rf7G__heroIntroContainer",
});
